import React, { useState } from "react";
import Table from "../../Common/Table";
import TableFieldsIssuedList from "../../../constants/DriverMedals/TableMetricList.json";
import MetricModal from "../MetricDetails";

const MetricsList = (props) => {
  const { list } = props;
  const [modalOpen, setModalOpen] = useState(false);
  const [activeItem, setActiveItem] = useState({});

  const getFieldValue = (item, key) => {
    switch (key) {
      case "name":
        return (
          <span onClick={() => handleRowClick(item)} className="edit-options">
            {item[key]}
          </span>
        );
      default:
        return item[key];
    }
  };

  const handleRowClick = (item) => {
    setActiveItem(item);
    setModalOpen(true);
  };
  const handleClose = () => {
    setActiveItem({});
    setModalOpen(false);
  };

  return (
    <>
      <Table
        list={list}
        getFieldValue={getFieldValue}
        fields={TableFieldsIssuedList}
      />
      {modalOpen && <MetricModal list={activeItem} handleClose={handleClose} />}
    </>
  );
};

export default MetricsList;
